<template>
  <div class="header" v-if="!hideHeader || scrollTop >= maxScrollTop + 48">
    <div class="layout-content header-content">
      <transition name="fade-nav-up" mode="out-in">
        <template v-if="!hideHeader">
          <div class="logo header-logo" v-show="scrollTop <= maxScrollTop + 48">
            <a :href="headerInfo.header_content ? 'javascript:void(0);' : 'https://www.infoq.cn'">
              <img :src="headerInfo.header_content" v-if="headerInfo.header_type === 2" alt="logo" />
              <img src="../../../assets/img/logo-new.png" v-else alt="logo" />
            </a>
          </div>
        </template>
      </transition>
      <slot name="nav">
        <div class="nav-search-wrap" v-show="scrollTop >= maxScrollTop + 48">
          <!-- 话题导航 -->
          <transition name="fade-nav-up" mode="out-in">
            <div class="two-level-nav" v-show="scrollTop >= maxScrollTop + 48">
              <div class="title" style="text-align: center">{{headerInfo.title}}</div>
              <!-- 活动已结束 -->
              <template v-if="eventStatu === 'end'">
                <div class="btn" v-if="linkType !== 1">
                  <gkButton color="blue" :disabled="true" size="height38">活动结束</gkButton>
                </div>
              </template>
              <template v-else>
                <div class="btn" v-if="linkType === 0">
                  <gkButton @click="handleClick" color="blue" size="height38">{{headerInfo.link && headerInfo.link.desc}}</gkButton>
                </div>
                <div class="btn" v-if="linkType === 2">
                  <Popover tag="div" color="weixin-qrcode" top="12" label="我的标签是自定义的提示框" position="bottom">
                    <gkButton color="blue" size="height38">{{headerInfo.link && headerInfo.link.desc}}</gkButton>
                    <div slot="content" class="weixin-qrcode">
                      <img :src="headerInfo.link.link" alt="">
                    </div>
                  </Popover>
                </div>
              </template>
            </div>
          </transition>
        </div>
      </slot>
      <template v-if="loginType">
        <div class="head-img" v-if="loginUser">
          <img :src="loginUser.avatar || defaultImg" :title="loginUser.nick" :alt="loginUser.nick">
          <div class="login-out" @click="loginOut">
            退出
          </div>
        </div>
        <div v-else class="login" @click="login"><span>登录</span> / <span>注册</span></div>
      </template>
    </div>
  </div>
</template>

<script>
/* eslint-disable */ 
import {mapState} from 'vuex'

import Popover from 'gkui/popup/Popover'
import gkButton from 'gkui/button'
import QrCode from '../../qrcode'
import utils from '../../../utils'

export default {
  name: 'header-pc',
  props: {
    loginType: {
      type: Number,
      default: 0
    },
    linkType: {
      type: Number,
      default: 0
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    maxScrollTop: {
      type: Number,
      default: 0
    },
    headerInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    eventStatu: {
      type: String
    }
  },
  components: {
    Popover,
    gkButton,
    QrCode
  },
  data () {
    return {
      scrollTop: 0,
      defaultImg: require('../../../assets/img/default-avatar.png')
    }
  },
  computed: {
    ...mapState(['loginUser'])
  },
  mounted () {
    window.addEventListener('scroll', this.listenerScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.listenerScroll)
  },
  methods: {
    listenerScroll (event) {
      this.scrollTop = window.scrollY
    },
    handleClick () {
      if (this.loginType && !this.loginUser) {
        let params = {
          cb: this.enter
        }
        utils.login(params)
        this.$Message.toast({
          message: '登录后才可报名活动'
        })
        utils.storage.set('loginAction', {
          options: this.enter
        })
        return
      }
      let gaButtonStatus = this.headerInfo.link.desc
      window.ga && window.ga('send', 'event', '报名按钮点击数', 'pc', gaButtonStatus)
      // TODO 表单跳转
      this.enter()
    },
    enter () {
      window.open(this.headerInfo.link.link)
    },
    /**
     * 路由跳转
     */
    navigation (path) {
      this.$router.push(path)
    },
    login () {
      this.$emit('login')
    },
    loginOut () {
      this.$emit('loginOut')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/common';

.header {
  width: 100%;
  background: #fff;
  box-shadow: 0px 5px 14px 1px rgba(20, 88, 212, 0.1);
}

.header-content {
  position: relative;
  display: flex;
  height: 69px;
  & .head-img {
    position: absolute; right: 0;
    padding: 15px 0;
    width: 40px;
    cursor: pointer;

    & img {
      display: block;
      width: 100%;
      border-radius: 50%;
    }

    &:hover {
      & .login-out {
        display: block;
      }
    }

    & .login-out {
      display: none;
      position: absolute;
      bottom: -40px; left: -20px;
      width: 80px;
      padding: 10px 20px;
      background: #fff;
      text-align: center;
      box-shadow: 0 2px 10px 0 rgba($color: #000000, $alpha: .1);
      &:hover {
        color: $blue;
      }
    }
  }

  & .login {
    position: absolute; right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 80px;
    cursor: pointer;

    & span:hover {
      color: $blue;
    }
  }
}
.logo {
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -16px;
  @extend %center;
  cursor: pointer;

  & img {
    display: block;
    height: 32px; width: auto;
  }
}

.nav-search-wrap {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  // overflow: hidden;

  &.gradient-layer:after {
    display: block;
    content: '';
    position: absolute; z-index: 4; left: 0; right: 0; bottom: 0;
    height: 16px;
    background: linear-gradient(to bottom,transparent, #fff 70%);
  }
}

.two-level-nav {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  @extend %transition;
  & .title {
    margin-right: 66px;
    width: 462px;
    color: #303030;
    font-weight: bold;
    font-size: 20px;
    @extend %row;
  }
  & .btn {
    width: 150px;
    .weixin-qrcode {
      padding: 0;
      width: 109px; height: 109px;
      img {
        width: 100%; height: 100%;
      }
    }
  }
}


.fade-one-level-nav-up-enter-active,
.fade-one-level-nav-up-leave-active {
  transition: all 0.5s ease;
}

.fade-one-level-nav-up-enter,
.fade-one-level-nav-up-leave-to {
  transform: translateY(-38px);
  opacity: 0;
}

.fade-nav-up-enter-active,
.fade-nav-up-leave-active {
  transition: all 0.5s ease;
}
.fade-nav-up-enter,
.fade-nav-up-leave-to {
  transform: translateY(28px);
  opacity: 0;
}
</style>
